import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="h-screen flex items-center justify-center text-sm text-zinc-500 font-mono-tight uppercase tracking-widest">
        Loading
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
